import styled from 'styled-components';

import { Container as ContainerDefault } from '../styles';

export const Container = styled(ContainerDefault)``;
